/**
 * Rozhraní poskytují URI pro referenci ukazující na data v podpisu
 */
export interface ISignatureReferenceUriGenerator {

    /**
     * Vygeneruje URI pro referenci ukazující na data v podpisu
     */
    getReferenceUri(): Promise<string>;
}
